@if (formControl()) {
<div class="datetime">
    <mat-form-field class="form-field">
        <input matInput [placeholder]="meta().name" class="form-control input-date" [formControl]="formControl()!"
            [matDatepicker]="datepicker" (dateChange)="onDateChange()"/>
        @if (formControl()?.value && !meta().readonly && !readonly()) {
        <button matSuffix mat-icon-button aria-label="Clear" (click)="onClear()">
            <mat-icon>close</mat-icon>
        </button>
        }
        <mat-hint><strong>{{meta().info}}</strong></mat-hint>
        <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
        <mat-datepicker #datepicker></mat-datepicker>
        @if (formControl()?.hasError('required')) {
        <mat-error>
            {{meta().name}} is <strong>required</strong>
        </mat-error>
        }
        @if (formControl()?.hasError('dateRange')) {
        <mat-error>
            End date must be after start date.
        </mat-error>
        }
    </mat-form-field>
    <mat-form-field class="form-field">
        <input matInput [matTimepicker]="timepicker" [formControl]="timeControl">
        <mat-timepicker #timepicker (selected)="onTimeChange($event)"/>
        <mat-timepicker-toggle [for]="timepicker" matSuffix />
    </mat-form-field>
</div>
}
